import { klasses } from '@/constants/klasses'

export const formatRiskData = (data = {}) => {
  const summary = {}
  // Recorremos los meses
  for (const month in data) {
    const monthData = data[month]
    // Recorremos los datos de cada mes (la key es la clase)
    for (const key in monthData) {
      const items = monthData[key]
      // Recorremos los items de cada mes
      items.forEach(item => {
        const attachmentType = item.attachment_type
        const total = item.total || 0
        const approved = item.approved || 0
        const risk = item.risk || 0
        // Si el attachment_type ya existe en el summary, sumamos los totales y aprobados
        if (summary[attachmentType]) {
          summary[attachmentType].total += total
          summary[attachmentType].approved += approved
          summary[attachmentType].risk += risk
        } else {
          // Si no existe, lo agregamos al summary
          summary[attachmentType] = { ...item, klass: klasses[key] }
        }
      })
    }
  }
  return Object.values(summary).map((summaryItem) => {
    return {
      compliance: `${summaryItem.approved}/${summaryItem.total}`,
      ...summaryItem
    }
  })
}
